import { Outlet, Route } from "react-router-dom";
// import { HomePage } from "../components/WebUi/Pages/Home/HomePage";
import { PricingPage } from "../components/WebUi/Pages/Pricing/Pricing";
import { AboutUsPage } from "../components/WebUi/Pages/AboutUs/AboutUs";
import { ContactUsPage } from "../components/WebUi/Pages/ContactUs/ContactUs";
import { PrivacyPage } from "../components/WebUi/Pages/PrivacyPolicy/Privacy";
import { TermsPage } from "../components/WebUi/Pages/Terms/Terms";
import ThankYou from "../components/WebUi/Pages/ContactUs/ThankYou";
import { FaqPage } from "../components/WebUi/Pages/FAQ/Faq";
import { Footer } from "../components/WebUi/Footer/Footer";
import { Navbar } from "../components/WebUi/Components/HomeV2/Navbar";

const HomePageRoutes = () => (
  <>
    {/* <Route path="/" element={<HomePage />} /> */}
    <Route
      element={
        <>
          <Navbar />
          <div style={{ backgroundColor: "#fffbe3" }}>
            <Outlet />
          </div>
          <Footer />
        </>
      }
    >
      <Route path="/contact" element={<ContactUsPage />} />
      <Route path="/faq" element={<FaqPage />} />
      <Route path="/about" element={<AboutUsPage />} />
      <Route path="/pricing" element={<PricingPage />} />
      <Route path="/privacy" element={<PrivacyPage />} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/contact/thankyou" element={<ThankYou />} />
    </Route>
  </>
);

export default HomePageRoutes;
